export enum ShipmentLoadEndpoint {
  Base = '/shipments',
  Loads = '/loads',
  TransportOrders = '/tos',
  Summary = '/summary',
  Milestones = '/milestones',
  Map = '/map',
  ContainerCharges = '/container-charges',
  Available = '/available',
}
